import { definePath } from '../../router/definePath';

export const HomePaths = {
  home: definePath('authenticated', { de: '/startseite', en: '/home' }),
} as const;
